var _circle, _path, _path2, _path3, _circle2, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _path12, _path13;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCyt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 1000 1000",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 500,
    cy: 500,
    r: 500,
    fill: "#202020"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M311.697 421.439L113.984 499.793L311.978 578.258L227.574 773.476L422.398 689.243L500.492 886.301L578.699 688.959L774.179 773.476L689.663 577.998L887 499.793L689.944 421.699L774.179 226.871L578.957 311.277L500.492 113.285L422.14 310.993L227.574 226.871L311.697 421.439ZM311.697 421.439L345.738 500.174L311.978 578.258L390.793 609.492L422.398 689.243L500.877 655.312L578.699 688.959L610.192 609.493L689.663 577.998L656.015 500.174L689.944 421.699L610.192 390.093L578.957 311.277L500.877 345.035L422.14 310.993L390.793 390.093L311.697 421.439Z",
    fill: "white",
    fillOpacity: 0.05
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M439.211 474.369L375.018 499.809L439.301 525.284L411.897 588.668L475.153 561.318L500.51 625.301L525.902 561.227L589.37 588.668L561.93 525.201L626.002 499.809L562.02 474.453L589.37 411.195L525.985 438.6L500.51 374.316L475.071 438.508L411.897 411.195L439.211 474.369ZM439.211 474.369L450.263 499.931L439.301 525.284L464.892 535.426L475.153 561.318L500.634 550.302L525.902 561.227L536.127 535.426L561.93 525.201L551.004 499.931L562.02 474.453L536.127 464.191L525.985 438.6L500.634 449.56L475.071 438.508L464.892 464.191L439.211 474.369Z",
    fill: "white",
    fillOpacity: 0.05
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M485.125 493.424L469.016 499.809L485.147 506.202L478.27 522.107L494.144 515.244L500.508 531.301L506.88 515.221L522.807 522.107L515.921 506.181L532 499.809L515.943 493.445L522.807 477.57L506.901 484.447L500.508 468.316L494.124 484.425L478.27 477.57L485.125 493.424ZM485.125 493.424L487.898 499.838L485.147 506.202L491.57 508.747L494.144 515.244L500.539 512.479L506.88 515.221L509.446 508.747L515.921 506.181L513.179 499.838L515.943 493.445L509.446 490.87L506.901 484.447L500.539 487.198L494.124 484.425L491.57 490.87L485.125 493.424Z",
    fill: "white",
    fillOpacity: 0.1
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 500,
    cy: 500,
    r: 481.5,
    stroke: "#E04520",
    strokeWidth: 37
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M501.5 886L557.359 968.5H445.641L501.5 886Z",
    fill: "#E04520",
    fillOpacity: 0.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M227.612 773.081L210.037 864.753L135.939 790.656L227.612 773.081Z",
    fill: "#E04520",
    fillOpacity: 0.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M773.781 226.911L791.356 135.239L865.453 209.336L773.781 226.911Z",
    fill: "#E04520",
    fillOpacity: 0.5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M114 499.801L36.75 552.195L36.75 447.406L114 499.801Z",
    fill: "#E04520",
    fillOpacity: 0.5
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M887 499.801L964.25 447.406L964.25 552.195L887 499.801Z",
    fill: "#E04520",
    fillOpacity: 0.5
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M773.78 773.079L865.452 790.655L791.355 864.752L773.78 773.079Z",
    fill: "#E04520",
    fillOpacity: 0.5
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M227.613 226.913L135.94 209.337L210.037 135.24L227.613 226.913Z",
    fill: "#E04520",
    fillOpacity: 0.5
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M500.5 114L446.373 33.75L554.627 33.75L500.5 114Z",
    fill: "#E04520",
    fillOpacity: 0.5
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 459.628,
    y: 500.414,
    width: 225.304,
    height: 225.304,
    transform: "rotate(135 459.628 500.414)",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 643.721,
    y: 316.312,
    width: 225.304,
    height: 225.304,
    transform: "rotate(135 643.721 316.312)",
    fill: "#F33030"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 643.721,
    y: 684.508,
    width: 225.304,
    height: 225.304,
    transform: "rotate(135 643.721 684.508)",
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 762.977,
    y: 423.895,
    width: 10.7099,
    height: 44.787,
    transform: "rotate(-165 762.977 423.895)",
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 794.015,
    y: 432.211,
    width: 10.7099,
    height: 44.787,
    transform: "rotate(-165 794.015 432.211)",
    fill: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 711.571,
    y: 615.746,
    width: 10.7099,
    height: 44.787,
    transform: "rotate(-165 711.571 615.746)",
    fill: "white"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 742.608,
    y: 624.062,
    width: 10.7099,
    height: 44.787,
    transform: "rotate(-165 742.608 624.062)",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M722.911 573.423C702.957 568.076 685.945 555.022 675.616 537.131C665.287 519.241 662.488 497.981 667.834 478.027C673.181 458.073 686.235 441.06 704.126 430.731C722.016 420.402 743.276 417.606 763.229 422.953L757.434 444.584C743.362 440.813 728.223 443.332 715.606 450.616C702.99 457.9 693.784 469.898 690.014 483.97C686.243 498.041 688.217 513.034 695.501 525.651C702.785 538.267 714.887 547.085 728.958 550.855L722.911 573.423Z",
    fill: "#E04520"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M783.922 428.496C803.876 433.843 821.139 446.661 831.467 464.551C841.796 482.441 844.595 503.702 839.249 523.656C833.902 543.61 820.848 560.622 802.958 570.951C785.067 581.28 763.556 584.315 743.603 578.969L749.65 556.398C763.722 560.168 778.861 558.35 791.477 551.066C804.093 543.782 813.299 531.785 817.07 517.713C820.84 503.641 818.866 488.648 811.582 476.032C804.298 463.416 792.197 453.897 778.126 450.126L783.922 428.496Z",
    fill: "#E04520"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCyt);
export default __webpack_public_path__ + "static/media/CYT.080f19a779239de652eefc75a81071a2.svg";
export { ForwardRef as ReactComponent };